import { Box, Heading } from '@chakra-ui/react'
import React from 'react'

const PageNotFound = () => {
  return (
    <Box>

        <Heading>404 Page not Found. Looks like you lost.</Heading>

    </Box>
  )
}

export default PageNotFound